import React from "react"
import { Icon, Tile } from "@/components"
import { useToggleCopilotChat } from "@/components/CopilotAnalyze/hooks/useToggleCopilotChat"

export const CopilotTile = () => {
    const { toggleChat } = useToggleCopilotChat()

    return (
        <Tile
            icon={<Icon icon="sparkles" />}
            orientation="vertical"
            size="md"
            variant="secondary"
            onClick={() => toggleChat()}
            data-plum-id="ask-copilot-tile"
        >
            Ask Copilot
        </Tile>
    )
}
